export function clearSigningIntent() {
  localStorage.removeItem('signing_payload')
  localStorage.removeItem('signing_params')
}
